"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowCDownIcon20Light = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var BaseIcon_1 = require("../../internal/BaseIcon");
exports.ArrowCDownIcon20Light = forwardRef_1.forwardRef('ArrowCDownIcon20Light', function (props, ref) {
    return (react_1.default.createElement(BaseIcon_1.BaseIcon, tslib_1.__assign({ ref: ref, viewBoxSize: 20 }, props),
        react_1.default.createElement("path", { d: "M16.603 7.021a.5.5 0 0 1 0 .708l-4.836 4.836a2.5 2.5 0 0 1-3.535 0L3.396 7.729a.5.5 0 0 1 .707-.708l4.836 4.836a1.5 1.5 0 0 0 2.121 0l4.836-4.836a.5.5 0 0 1 .707 0Z" })));
});
